import React from 'react';
import { Redirect } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useTheme } from '../../ThemeContext';

import Helmet from '../../components/Helmet';
import Header from '../../components/Header';
import Sider from '../../components/Sider';

import {
  Section,
  Wrapper,
  Content,
  Panel,
  PanelInner,
  Information,
  Title,
  Subtitle,
  Text,
  Button,
  Center,
} from './BlackHolePage.style';

const BlackHolePage = () => {
  const intl = useIntl();
  const theme = useTheme();
  const history = useHistory();
  const { auth } = useSelector((state) => state.firebase);

  const renderInformation = () => {
    return (
      <Center>
        <Information theme={theme.content.information.default}>
          <Title>{intl.formatMessage({ id: 'BLACK_HOLE.404' })}</Title>
          <Subtitle>{intl.formatMessage({ id: 'BLACK_HOLE.OOOPS' })}</Subtitle>
          <Text>
            {intl.formatMessage({
              id: `BLACK_HOLE.THAT_PAGE_DOESN'T_EXIST_OR_IS_UNAVAILABLE`,
            })}
          </Text>
          <Button
            theme={theme.button.default}
            onClick={() => history.push('/')}
          >
            {intl.formatMessage({
              id: `BLACK_HOLE.GO_BACK_TO_HOME`,
            })}
          </Button>
        </Information>
      </Center>
    );
  };

  return (
    <>
      {auth.isEmpty ? (
        <Redirect to={{ pathname: '/' }} />
      ) : (
        <>
          <Helmet title={intl.formatMessage({ id: 'PAGE_TITLE.404' })} />
          <Section>
            <Sider />
            <Wrapper>
              <Header title={intl.formatMessage({ id: 'PAGE_TITLE.404' })} />
              <Content>
                <Panel theme={theme.content.panel.default}>
                  <PanelInner>{renderInformation()}</PanelInner>
                </Panel>
              </Content>
            </Wrapper>
          </Section>
        </>
      )}
    </>
  );
};

export default BlackHolePage;
